<template>
  <div class="categoria-pesquisa">
    <div class="input-group">
      <input type="search" class="form-control" placeholder="Pesquisar reunião"
             v-model="busca" autocomplete="off" @input="aoDigitar"
             @focus="mostrarSugestoes = true" @blur="fecharSugestoes" @keyup.enter.prevent="pesquisar">
      <div class="input-group-append">
        <button type="button" class="btn btn-secondary text-nowrap px-3" @click="pesquisar">
          <i class="fa-solid fa-magnifying-glass"></i><span class="ml-2 d-none d-md-inline">Pesquisar</span>
        </button>
      </div>
    </div>
    <div class="categoria-sugestoes shadow-sm" v-if="mostrarSugestoes">
      <button type="button" class="categoria-sugestao" v-for="categoria in categoriasFiltradas"
              :key="categoria.id_categoria" @mousedown.prevent="selecionar(categoria)">
        {{ categoria.nome }}
      </button>
      <div class="text-muted small p-3" v-if="!categoriasFiltradas.length">Nenhuma categoria encontrada.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalendarioCategoriaPesquisa',
  props: {
    categorias: {type: Array, default: () => []},
    value: {default: null}
  },
  data() {
    return {busca: '', mostrarSugestoes: false, preservarBusca: false};
  },
  computed: {
    categoriasDisponiveis() {
      const categorias = this.categorias.map(categoria => ({
        ...categoria,
        id_categoria: +categoria.id_categoria,
        nome: categoria.nome_singular || categoria.nome_categoria
      }));
      if (!categorias.some(categoria => categoria.id_categoria === 1)) {
        categorias.unshift({id_categoria: 1, nome: 'Outras'});
      }
      return categorias;
    },
    categoriasFiltradas() {
      const termo = this.normalizarTexto(this.busca);
      return this.categoriasDisponiveis
        .filter(categoria => !termo || this.normalizarTexto(categoria.nome).includes(termo))
        .slice(0, 8);
    }
  },
  watch: {
    value(valor) {
      if (!valor && !this.preservarBusca) this.busca = '';
    }
  },
  methods: {
    normalizarTexto(texto) {
      return String(texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    aoDigitar() {
      this.mostrarSugestoes = true;
      if (this.value) {
        this.preservarBusca = true;
        this.$emit('limpar');
        this.$nextTick(() => { this.preservarBusca = false; });
      }
    },
    fecharSugestoes() {
      setTimeout(() => { this.mostrarSugestoes = false; }, 150);
    },
    selecionar(categoria) {
      this.busca = categoria.nome;
      this.mostrarSugestoes = false;
      this.$emit('selecionar', categoria);
    },
    pesquisar() {
      if (this.categoriasFiltradas.length === 1) {
        this.selecionar(this.categoriasFiltradas[0]);
      } else {
        this.mostrarSugestoes = true;
      }
    }
  }
};
</script>

<style scoped>
.categoria-pesquisa { position: relative; z-index: 20; }
.categoria-sugestoes {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  left: 0;
  overflow: hidden;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fff;
}
.categoria-sugestao {
  display: block;
  width: 100%;
  padding: 10px 12px;
  border: 0;
  border-bottom: 1px solid #eee;
  background: #fff;
  color: #212529;
  text-align: left;
}
.categoria-sugestao:last-child { border-bottom: 0; }
.categoria-sugestao:hover,
.categoria-sugestao:focus { background: #f2f4f7; outline: none; }
</style>
